import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { catchError, map, mergeMap, Observable, of, switchMap } from 'rxjs';

import { UserDataService } from '../services/userdata.service';

import {
  fetchAsyncUserTasks,
  fetchAsyncUserTasksFailure,
  fetchAsyncUserTasksSuccess,
  deleteAsyncUserTask,
  deleteAsyncUserTaskSuccess,
  deleteAsyncUserTaskFailure,
  fetchPreferences,
  fetchPreferencesSuccess,
  fetchPreferencesFailure,
  updatePreferences,
  updatePreferencesSuccess,
  updatePreferencesFailure
} from './userdata.actions';

@Injectable()
export class UserDataEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly userDataService: UserDataService
  ) {}

  fetchAsyncUserTasks$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType(fetchAsyncUserTasks),
        mergeMap(() =>
          this.userDataService.fetchAsyncUserTasks().pipe(
            map((data) =>
              fetchAsyncUserTasksSuccess({
                data
              })
            ),
            catchError((error: any) => of(fetchAsyncUserTasksFailure({ error })))
          )
        )
      )
  );

  deleteAsyncUserTask$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteAsyncUserTask),
      mergeMap(({ id }) =>
        this.userDataService.deleteAsyncUserTask(id).pipe(
          map(() => deleteAsyncUserTaskSuccess({ id })),
          catchError((error) => of(deleteAsyncUserTaskFailure({ error })))
        )
      )
    )
  );

  fetchPreferences = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType(fetchPreferences),
        switchMap(() =>
          this.userDataService.fetchPreferences().pipe(
            map((data) => fetchPreferencesSuccess({ data })),
            catchError((error: any) => of(fetchPreferencesFailure({ error })))
          )
        )
      )
  );

  updatePreferences = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType(updatePreferences),
        switchMap((action) =>
          this.userDataService.updatePreferences(action.data).pipe(
            map((data) => updatePreferencesSuccess({ data })),
            catchError((error: any) => of(updatePreferencesFailure({ error })))
          )
        )
      )
  );
}
